import type { QuotePatchRequirementInput } from '../../../../schema/generated/schema';

export type QuotePresetSavePatch = QuotePatchRequirementInput & {
  kind?: string;
};

export type QuotePresetPatchJson = {
  kind?: string;
  menu?: string;
  version?: number;
  /** API / stored shape */
  add_requirements?: unknown;
  /** Quote presets microfrontend shape (see toggleEditView in index.tsx) */
  requirements?: unknown;
};

export const QUOTE_PRESET_STANDARD_INSPECTION_LABEL = 'Standard Inspection';

export function isQuotePresetPatchEmpty(patch: unknown): boolean {
  if (patch == null) return true;
  if (typeof patch !== 'object' || Array.isArray(patch)) return false;

  const { add_requirements: add, requirements: req } =
    patch as QuotePresetPatchJson;

  // API shape: [] means nothing to persist — ignore stale microfrontend `requirements`.
  if (Array.isArray(add) && add.length === 0) return true;

  const hasAdd = Array.isArray(add) ? add.length > 0 : add != null;
  const hasReq = Array.isArray(req) ? req.length > 0 : req != null;
  return !hasAdd && !hasReq;
}
